import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { IconComponent } from '../../../components/icon/icon.component';
import { FlyoutMenuComponent } from '../../../components/flyout-menu/flyout-menu.component';
import { FlyoutMenuToggleDirective } from '../../../components/flyout-menu/flyout-menu-toggle.directive';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { FlyoutMenuItemDirective } from '../../../components/flyout-menu/flyout-menu-item.directive';
import { FileFormat } from '../../../services/export/export.domain';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-toolbar-item-export',
  templateUrl: 'toolbar-item-export.component.html',
  styleUrls: ['toolbar-item-export.component.scss'],
  imports: [
    IconComponent,
    FlyoutMenuComponent,
    FlyoutMenuToggleDirective,
    IconButtonComponent,
    TranslatePipe,
    TranslateDirective,
    AsyncPipe,
    FlyoutMenuItemDirective,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarItemExportComponent {
  @Input() fileFormats: Array<FileFormat>;
  @Input() autoSizeOverride: boolean = true;
  @Input() tdWbIconButtonBackground: IconButtonBackground = 'grey';

  @Output() readonly onExport: EventEmitter<FileFormat> = new EventEmitter<FileFormat>();

  breakpointChanges: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService) {
    if (this.autoSizeOverride) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  showFormatsDropDown(): boolean {
    return Array.isArray(this.fileFormats) && this.fileFormats.length > 1;
  }

  export(selectedFileFormat?: FileFormat): void {
    this.onExport.emit(this.getFileFormat(selectedFileFormat));
  }

  private getFileFormat(selectedFileFormat: FileFormat): FileFormat {
    if (selectedFileFormat !== undefined) {
      return selectedFileFormat;
    }
    if (Array.isArray(this.fileFormats) && this.fileFormats.length > 0) {
      return this.fileFormats[0];
    }
    return FileFormat.CSV;
  }
}
